const STATUS_TINDAKAN = {
  butuh_tindakan: "0",
  menunggu_pihak_lain: "1",
  selesai: "2",
  semua: "3",
  statistik: "4",
};

const MENUNGGU_PIHAK_LAIN = {
  mahasiswa: 0,
  dosen: 1,
};

export { STATUS_TINDAKAN, MENUNGGU_PIHAK_LAIN };
